import { create } from "zustand";
import type { ModalKey, ModalPropsMap } from "@/components/ModalHost/type";

type ModalState<K extends ModalKey> = {
  open: boolean;
  props?: ModalPropsMap[K];
};

type ModalStateMap = {
  [K in ModalKey]?: ModalState<K>;
};

interface ModalStore {
  modals: ModalStateMap;

  openModal: <K extends ModalKey>(key: K, props: ModalPropsMap[K]) => void;

  closeModal: (key: ModalKey) => void;
}

export const useModalStore = create<ModalStore>((set) => ({
  modals: {},

  openModal: (key, props) => {
    return set((state) => ({
      modals: {
        ...state.modals,
        [key]: {
          open: true,
          props,
        },
      },
    }));
  },

  closeModal: (key) =>
    set((state) => ({
      modals: {
        ...state.modals,
        [key]: {
          ...state.modals[key],
          open: false,
        },
      },
    })),
}));
